var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 50,
    viewBox: "0 0 184 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.308 48.7868L97.7087 37.4636V10.6924H93.2348V32.1903L65.9186 -0.00805664L64.5371 1.20514L73.5089 11.7842V39.2834H78.0741V17.1789L105.926 50.0041L107.308 48.7868ZM169.165 10.7005V35.1222H184.008V39.3037H164.596V10.7005H169.165ZM151.587 39.3037H130.813V10.7005H151.591V15.1165H135.378V23.0225H150.9V27.2081H135.378V34.8917H151.587V39.3037ZM112.091 10.7005H116.657V39.3037H112.091V10.7005ZM47.7409 15.4805L41.8101 29.0885H53.6718L47.7409 15.4805ZM55.3113 33.2741H40.1269L37.483 39.3198H32.7192L45.2995 10.7166H50.1863L62.7666 39.3198H58.0029L55.3113 33.2741ZM4.56545 34.8917H10.7067C17.5586 34.8917 20.4446 29.7639 20.3255 24.7412C20.2025 19.9248 17.3164 15.1205 10.7067 15.1205H4.5734L4.56545 34.8917ZM10.7067 10.7045C20.2858 10.7045 24.6526 17.7006 24.7717 24.7614C24.9305 31.9881 20.524 39.3198 10.7067 39.3198H-0.0117188V10.7005L10.7067 10.7045Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0e3b6d16.svg";
export { ForwardRef as ReactComponent };